import { useQuery } from "@tanstack/react-query";
import { ISailFeedback } from "../declarations";
import { createApiClient } from "../utilities/apiClient";

const GetSailInfoFeedback = async (guid: string): Promise<ISailFeedback[]> => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get<ISailFeedback[]>(
        `/api/SailInfo/GetSailInfoFeedback/${encodeURIComponent(guid)}`,
    );
    return response.data;
};

export const useGetSailInfoFeedback = (guid: string) =>
    useQuery<ISailFeedback[]>({
        queryKey: [
            "GetSailInfoFeedback",
            {
                guid: guid ?? null,
            },
        ],
        queryFn: () => {
            if (!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoFeedback");
            }
            return GetSailInfoFeedback(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
        placeholderData: [],
    });
